import { useContext } from "react";
import routes from "../config/routes";
import { PortalConfigContext } from "../providers/PortalConfigProvider";
import { Layouts } from "../config/constants";

export const useRoutes = () => {
  const portalConfig = useContext(PortalConfigContext);

  return routes.filter((route) => {
    if (route.layout === Layouts.DASHBOARD) {
      return true;
    }
    return !!portalConfig.login;
  });
};
